import { wxLogin,wxUserInfo, wxLogout} from '@/assets/js/api/'
import { getToken, setToken, removeToken } from '@/assets/js/auth'


let token = getToken();
const getDefaultState = () => {
	token = getToken();
	return {
		token: token || '',
		user_name:''
	}
}
const state = getDefaultState()
const mutations = {
	RESET_STATE: (state) => {
		Object.assign(state, getDefaultState())
	},
	SET_TOKEN:(state, token) => {
		state.token = token;
	},
	SET_USER_NAME:(state, user_name)=>{
		state.user_name = user_name;
	}
}

const actions = {
	login({ commit, state }, code) {
		return new Promise((resolve, reject) => {
			wxLogin({code:code}).then(response => {
				const { data } = response;
				commit('SET_TOKEN', data.token);
				commit('SET_USER_NAME', data.user_name);
				resolve(data);
				setToken(data.token);
			}).catch(error => {
				reject(error)
			})
		})
	},
	userinfo({commit, state}){
		return new Promise((resolve, reject) => {
			wxUserInfo().then(response => {
				const { data } = response;
				commit('SET_USER_NAME', data.user_name);
				resolve(data);
			}).catch(error => {
				reject(error)
			})
		})
	},
	logout({ commit, state }) {
		return new Promise((resolve, reject) => {
			/*removeToken()
			commit('RESET_STATE');
			resolve({state:1,message:'退出成功'});
			return;*/
			wxLogout().then((res) =>{
				removeToken()
				commit('RESET_STATE')
				resolve(res)
			}).catch((error) =>{
				reject(error)
			})
			// logout(state.token).then(() => {
			// 	removeToken() // must remove  token  first
			// 	resetRouter()
			// 	commit('RESET_STATE')
			// 	resolve()
			// }).catch(error => {
			// 	reject(error)
			// })
		})
	},
	resetToken({ commit }) {
		return new Promise(resolve => {
			removeToken() // must remove  token  first
			commit('RESET_STATE')
			resolve()
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}


// WEBPACK FOOTER //
// ./src/store/user.js